import { Search as SearchIcon } from '@mui/icons-material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import {
  CircularProgress,
  IconButton,
  InputAdornment,
  SxProps,
  TextField,
} from '@mui/material';

export function TableSearch(props: {
  searchText: string;
  onChange: (value: string) => void;
  hint?: string;
  isSearching?: boolean;
  sx?: SxProps;
}) {
  return (
    <TextField
      sx={{ ...props.sx }}
      variant="outlined"
      value={props.searchText}
      onChange={(event) => props.onChange(event.target.value)}
      fullWidth
      placeholder={props.hint}
      InputProps={{
        sx: {
          alignContent: 'center',
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: props.isSearching ? (
          <CircularProgress size={'20px'} />
        ) : props.searchText ? (
          <InputAdornment onClick={() => props.onChange('')} position="start">
            <IconButton>
              <CloseOutlinedIcon />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
}
